module.exports = {
  address: "0xBfc14Fd3d39db48e7237D168341e3627EEf79c5b",
  address_test: '0xfa59bd05d8a5d8f8983d6f33fa561e63604b349a',
  abi: require('./Claim.abi.json')
}
